<template>
  <div class="whatsapp-contact-action-mobile">
    <v-btn
      class="whatsapp-contact-action-mobile__btn"
      :href="whatsappLink"
      target="_blank"
      :color="getAssets.colors.whatsapp.contactButton"
      :style="{ color: getAssets.colors.whatsapp.contactButtonText }"
    >
      <v-icon class="mr-2">whatsapp</v-icon>
      {{ buttonLabel }}
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'WhatsappContactCardActionMobile',
  props: {
    whatsappLink: {
      type: String,
      required: true
    },
    isCommunity: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['GET_ASSETS']),
    getAssets() {
      return this.GET_ASSETS
    },
    buttonLabel() {
      return this.isCommunity ? 'Entrar na comunidade' : 'Receber ofertas'
    }
  }
}
</script>

<style lang="scss" scoped>
.whatsapp-contact-action-mobile {
  width: 100%;
  display: flex;
}

.whatsapp-contact-action-mobile__btn {
  width: 100%;
  flex: 1 1 auto;
  text-transform: none;
  font-weight: 500;
  white-space: normal;
}
</style>
